module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("开课Checklist管理")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "toolbar"
  }, [_c('div', {
    staticClass: "publish-info"
  }, [(_vm.latestVersionId) ? _c('span', [_vm._v("最近发布：版本 " + _vm._s(_vm.latestVersionId) + " · " + _vm._s(_vm.latestPublishTime || '—'))]) : _c('span', {
    staticClass: "publish-empty"
  }, [_vm._v("最近发布：暂未发布")])]), _vm._v(" "), _c('div', {
    staticClass: "toolbar-actions"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        return _vm.openStageModal()
      }
    }
  }, [_vm._v("新增分类")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.publishLoading
    },
    on: {
      "click": _vm.publish
    }
  }, [_vm._v("发布")])], 1)]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "30px 0"
    }
  }, [_c('Spin', {
    attrs: {
      "size": "large"
    }
  })], 1) : _c('div', [_vm._l((_vm.stages), function(stage) {
    return _c('div', {
      key: stage.id,
      staticClass: "stage-block"
    }, [_c('div', {
      staticClass: "stage-head"
    }, [_c('span', {
      staticClass: "stage-name",
      class: {
        'is-offline': !_vm.isEnabled(stage.enabled)
      }
    }, [_vm._v(_vm._s(stage.name))]), _vm._v(" "), _c('span', {
      staticClass: "stage-sort"
    }, [_vm._v("排序：" + _vm._s(stage.sort))]), _vm._v(" "), (!_vm.isEnabled(stage.enabled)) ? _c('Tag', {
      attrs: {
        "color": "default"
      }
    }, [_vm._v("已下线")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "stage-actions"
    }, [_c('Button', {
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.openItemModal(null, stage)
        }
      }
    }, [_vm._v("新增选项")]), _vm._v(" "), _c('Button', {
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.openStageModal(stage)
        }
      }
    }, [_vm._v("编辑")]), _vm._v(" "), _c('Button', {
      attrs: {
        "size": "small",
        "type": _vm.isEnabled(stage.enabled) ? 'warning' : 'success'
      },
      on: {
        "click": function($event) {
          return _vm.toggleStage(stage)
        }
      }
    }, [_vm._v(_vm._s(_vm.isEnabled(stage.enabled) ? '下线' : '上线'))])], 1)], 1), _vm._v(" "), _c('Table', {
      attrs: {
        "columns": _vm.itemColumns,
        "data": stage.items || [],
        "border": "",
        "stripe": "",
        "size": "small"
      }
    })], 1)
  }), _vm._v(" "), (!_vm.stages.length) ? _c('div', {
    staticClass: "empty-tip"
  }, [_vm._v("暂未配置分类，请先新增分类")]) : _vm._e()], 2), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.stageForm.id ? '编辑分类' : '新增分类',
      "width": "480"
    },
    model: {
      value: (_vm.showStageModal),
      callback: function($$v) {
        _vm.showStageModal = $$v
      },
      expression: "showStageModal"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "名称",
      "required": ""
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入分类名称",
      "maxlength": 50
    },
    model: {
      value: (_vm.stageForm.name),
      callback: function($$v) {
        _vm.$set(_vm.stageForm, "name", $$v)
      },
      expression: "stageForm.name"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "排序"
    }
  }, [_c('InputNumber', {
    attrs: {
      "min": 0,
      "placeholder": "留空放到最后"
    },
    model: {
      value: (_vm.stageForm.sort),
      callback: function($$v) {
        _vm.$set(_vm.stageForm, "sort", $$v)
      },
      expression: "stageForm.sort"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showStageModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": _vm.saveStage
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.itemForm.id ? '编辑选项' : '新增选项',
      "width": "560"
    },
    model: {
      value: (_vm.showItemModal),
      callback: function($$v) {
        _vm.showItemModal = $$v
      },
      expression: "showItemModal"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "所属分类",
      "required": ""
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择分类"
    },
    model: {
      value: (_vm.itemForm.stage),
      callback: function($$v) {
        _vm.$set(_vm.itemForm, "stage", $$v)
      },
      expression: "itemForm.stage"
    }
  }, _vm._l((_vm.stages), function(stage) {
    return _c('Option', {
      key: stage.id,
      attrs: {
        "value": stage.id
      }
    }, [_vm._v(_vm._s(stage.name))])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "标题",
      "required": ""
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入标题",
      "maxlength": 200
    },
    model: {
      value: (_vm.itemForm.title),
      callback: function($$v) {
        _vm.$set(_vm.itemForm, "title", $$v)
      },
      expression: "itemForm.title"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "说明"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "请输入说明"
    },
    model: {
      value: (_vm.itemForm.guideText),
      callback: function($$v) {
        _vm.$set(_vm.itemForm, "guideText", $$v)
      },
      expression: "itemForm.guideText"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "提示"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入提示"
    },
    model: {
      value: (_vm.itemForm.hint),
      callback: function($$v) {
        _vm.$set(_vm.itemForm, "hint", $$v)
      },
      expression: "itemForm.hint"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "类型",
      "required": ""
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择类型"
    },
    model: {
      value: (_vm.itemForm.itemType),
      callback: function($$v) {
        _vm.$set(_vm.itemForm, "itemType", $$v)
      },
      expression: "itemForm.itemType"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("勾选")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("必须填文字")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("必须传图")])], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "排序"
    }
  }, [_c('InputNumber', {
    attrs: {
      "min": 0,
      "placeholder": "留空放到最后"
    },
    model: {
      value: (_vm.itemForm.sort),
      callback: function($$v) {
        _vm.$set(_vm.itemForm, "sort", $$v)
      },
      expression: "itemForm.sort"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showItemModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": _vm.saveItem
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b43e160e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/TchOnboardingManage.vue
// module id = 1951
// module chunks = 8